import React, { FC } from 'react';
import styled from 'styled-components';
import { CustomBlockContent } from './CustomBlockContent';

interface GreySectionProps {
  title: string;
  content?: string;
  toggle: () => void;
}

export const GreySection: FC<GreySectionProps> = ({ title, content }) => {
  return (
    <StyledGreySection>
      <div className="grey-row">
        <div>
          <h2> {title} </h2>
          {content && (
            <div className="summary-paragraph">
              <CustomBlockContent blocks={content} />
            </div>
          )}
        </div>
      </div>
    </StyledGreySection>
  );
};

const StyledGreySection = styled.div`
  .grey-row {
    background: var(--lightgrey);
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    padding-bottom: 50px;
    @media (max-width: 868px) {
      min-height: 70vh;
      align-items: center;
    }

    .summary-paragraph {
      text-align: center;
      font-family: Nimbus;
      font-style: italic;
      font-size: 1.3em;
      line-height: 1.2em;
      margin: 20px 15%;
      color: var(--darkestgrey);
      max-width: 868px;
      @media (max-width: 868px) {
        column-count: 1;
        padding: 20px 0;
        padding: 0 15px;
        font-size: 0.8em;
      }
    }

    h2 {
      margin-top: 50px;
      width: 100%;
      text-align: center;
    }
  }
`;
